import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
    selector: '[fiFadeText]',
    exportAs: 'fiFadeText',
    standalone: false,
})
export class FadeTextDirective {
    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
    ) {}

    showElement() {
        this.renderer.addClass(this.elementRef.nativeElement, 'in');
        setTimeout(() => {
            this.renderer.removeClass(this.elementRef.nativeElement, 'in');
        }, 500);
    }
}
